<label for={{path}} [class]="claseLabel">{{label}}</label>
<div class="input-group form-group">
    <input [ngClass]="{'is-invalid': control.invalid && control.dirty, 'is-valid': control.valid}" [type]="type" [placeholder]="placeholder" class="form-control" [(ngModel)]="value" [readonly]="!!isReadOnly">
    <div class="input-group-append">
        <button (click)="openModal()" data-backdrop="false" [ngClass]="{'btn-outline-danger': control.invalid && control.dirty, 'btn-outline-success': control.valid}" class="btn btn-outline-secondary" type="button" id="button-addon2">
                <i class="fa fa-search" aria-hidden="true"></i>
        </button>
    </div>
</div>
<app-lfsa-error-msg [control]="control" [label]="label"></app-lfsa-error-msg>


<!-- <div class="modal fade" [id]="path" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{path}}</h5>
              <button type="button" #closebutton class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <form [formGroup]="formulario" novalidate class="form-group" *ngIf="!mostrar">
                  <div class="row">
                      <div class="form-group col-md-6">
                          <app-lfsa-input [type]="'number'" [placeholder]="'Código'" [label]="'Código desde:'" [id]="'codigo1'" formControlName="codigo1" [control]="formulario.get('codigo1')"></app-lfsa-input>
                      </div>
                      <div class="form-group col-md-6">
                          <app-lfsa-input [type]="'number'" [placeholder]="'Código'" [label]="'Código hasta:'" [id]="'codigo2'" formControlName="codigo2" [control]="formulario.get('codigo2')"></app-lfsa-input>
                      </div>
                      <div class="form-group col-md-6">
                          <app-lfsa-input [type]="'number'" [placeholder]="'RUC'" [label]="'RUC desde:'" [id]="'ruc1'" formControlName="ruc1" [control]="formulario.get('ruc1')"></app-lfsa-input>
                      </div>
                      <div class="form-group col-md-6">
                          <app-lfsa-input [type]="'number'" [placeholder]="'RUC'" [label]="'RUC hasta:'" [id]="'ruc2'" formControlName="ruc2" [control]="formulario.get('ruc2')"></app-lfsa-input>
                      </div>
                      <div class="form-group col-md-6">
                          <app-lfsa-input [placeholder]="'Nombre'" [label]="'Nombre:'" [id]="'nombre'" formControlName="nombre" [control]="formulario.get('nombre')"></app-lfsa-input>
                      </div>

                  </div>
                  <button class="btn btn-outline-success" (click)="mostrarTabla()">BUSCAR</button>
              </form>
              <div *ngIf="mostrar">
                  <div *ngIf="!loading">
                      <button class="btn btn-outline-success" (click)="mostrarFormulario()">NUEVA BUSCAR</button>
                      <ag-grid-angular style="width: 100%; height: 450px;" class="ag-theme-material mt-3" [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" [pagination]="true">
                      </ag-grid-angular>
                  </div>
                  <div class="containerLoader" *ngIf="loading">
                      <div class="item-1"></div>
                      <div class="item-2"></div>
                      <div class="item-3"></div>
                      <div class="item-4"></div>
                      <div class="item-5"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div> -->